var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconModal',_vm._b({attrs:{"alertClass":"warning","iconClass":"fa-triangle-exclamation"},on:{"closepopup":function($event){return _vm.$emit('closepopup')}}},'IconModal',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }